import PropTypes from "prop-types";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getBrandDisplayName, getRobotsMetaTag } from "app/reducers/partnerSelector";
import { connect } from "react-redux";
import { OFFER_PRICE_TYPES } from "app/constants";

const FicheProduitHeadMetadata = ({
	ficheProduit = {},
	desktopSlideShowPhotos = [],
	robotsMetaTag,
	brandDisplayName,
}) => {
	let metaDescription = "page.description.product.exclusive";

	switch (ficheProduit?.fromPriceType?.type) {
		case OFFER_PRICE_TYPES.FROM_PRICE_TYPE_SAVE_UP_TO:
			metaDescription = "page.description.product.saveupto";
			break;
		case OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM:
		case OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM_WITH_FLIGHT:
			metaDescription = "page.description.product.from";
			break;
		case OFFER_PRICE_TYPES.FROM_PRICE_TYPE_EXCLUSIVE:
			metaDescription = "page.description.product.exclusive";
			break;
		default:
			metaDescription = "page.description.product.catalog";
			break;
	}

	const ogImageAlt = `${ficheProduit?.name} ${ficheProduit?.category}* | ${brandDisplayName}`;

	return (
		<HeadMetadata
			description={metaDescription}
			descriptionAttributes={{
				pricingValue: ficheProduit?.fromPriceType?.value,
				country: ficheProduit?.country,
			}}
			title="page.title.product"
			titleAttributes={{ name: ficheProduit.name, category: ficheProduit.category }}
			robotsMetaTag={robotsMetaTag}
			imageUrl={
				desktopSlideShowPhotos && desktopSlideShowPhotos[0]
					? desktopSlideShowPhotos[0].url
					: ""
			}
		>
			<meta property="og:image:alt" content={ogImageAlt} />
		</HeadMetadata>
	);
};

FicheProduitHeadMetadata.propTypes = {
	ficheProduit: PropTypes.object,
	brandDisplayName: PropTypes.string,
	desktopSlideShowPhotos: PropTypes.array,
	robotsMetaTag: PropTypes.array,
};

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		robotsMetaTag: robotsMetaTag?.product,
		brandDisplayName: getBrandDisplayName(state),
	};
};

export default connect(mapStateToProps)(FicheProduitHeadMetadata);
